<div class="container-fluid fw-medium py-4 px-5">
  <div class="row ml-22">
    <div class="col-12">
      <div
        class="d-flex justify-content-between align-items-center position-relative stepper-container"
        style="margin-top: 17px"
        *ngIf="!isStepperHidden"
      >
        <div
          class="d-flex align-items-center step-item"
          [class.active]="currentStep >= 1"
        >
          <div class="step-circle me-2">1</div>
          <span class="step-label" [class.text-warning]="currentStep >= 1">{{
            "patientCreate.step.personal" | translate
          }}</span>
        </div>

        <div
          class="flex-grow-1 mx-3 step-line"
          [class.active]="currentStep >= 2"
        ></div>

        <div
          class="d-flex align-items-center step-item"
          [class.active]="currentStep >= 2"
        >
          <div class="step-circle me-2">2</div>
          <span class="step-label" [class.text-warning]="currentStep >= 2">{{
            "patientCreate.medicalInformation" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="patientForm" (ngSubmit)="onSubmit()">
    <app-patient-personal-info-step
      *ngIf="currentStep === 1"
      [patientForm]="patientForm"
      [nationalities]="nationalities"
      [occupations]="occupations"
      [genders]="genders"
      [maritalStatuses]="maritalStatuses"
      [countries]="countries"
      [cities]="cities"
      [districts]="districts"
      [organizations]="organizations"
      [facilities]="facilities"
      [isSystemAdmin]="isSystemAdmin"
      [todayDate]="todayDate"
      [defaultPatientCountry]="defaultPatientCountry"
      [defaultEmergencyContactCountry]="defaultEmergencyContactCountry"
      (countryChange)="onCountryChangeFromChild($event)"
      (cityChange)="onCityChangeFromChild($event)"
      (organizationChange)="onOrganizationChangeFromChild($event)"
      (dateInput)="onDateInput($event)"
      (nextStep)="onSubmit()"
      (checkExistence)="onCheckPatientExistence()"
    ></app-patient-personal-info-step>

    <div class="" *ngIf="currentStep === 2">
      <app-patient-medical-info-step
        *ngIf="currentStep === 2"
        [patientForm]="patientForm"
        [currentStep]="currentStep"
        [livingConditionsOptions]="livingConditionsOptions"
        [skinTypeOptions]="skinTypeOptions"
        [dietTypeOptions]="dietTypeOptions"
        [bloodTypeOptions]="bloodTypeOptions"
        [alcoholConsumptionOptions]="alcoholConsumptionOptions"
        [smokingStatusOptions]="smokingStatusOptions"
        [allergyCategories]="allergyCategories"
        [medications]="medications"
        [surgeries]="surgeries"
        [immunizationStatus]="immunizationStatus"
        [familyMedicalHistory]="familyMedicalHistory"
        [chronicConditionArray]="chronicConditionArray"
        [results]="results"
        [showDropdown]="showDropdown"
        [selectedAllergies]="selectedAllergies"
        [selectedMedications]="selectedMedications"
        [selectedSurgeries]="selectedSurgeries"
        [selectedWoundCareProducts]="selectedWoundCareProducts"
        [selectedAntibiotics]="selectedAntibiotics"
        [selectedDebridements]="selectedDebridements"
        [selectedFamilyHistory]="selectedFamilyHistory"
        [selectedImmunizations]="selectedImmunizations"
        [selectedVacType]="selectedVacType"
        [selectedVacSubOptions]="selectedVacSubOptions"
        [vacTouched]="vacTouched"
        [accordionState]="accordionState"
        (toggleAllergy)="toggleAllergy($event)"
        (toggleMedication)="toggleMedication($event)"
        (toggleSurgery)="toggleSurgery($event)"
        (toggleWoundCareProduct)="toggleWoundCareProduct($event)"
        (toggleAntibiotic)="toggleAntibiotic($event)"
        (toggleDebridement)="toggleDebridement($event)"
        (toggleFamilyHistory)="toggleFamilyHistory($event)"
        (toggleImmunization)="toggleImmunization($event)"
        (toggleAccordion)="toggleAccordion($event)"
        (selectChronicCondition)="selectItem($event)"
        (removeChronicCondition)="removeCondition($event)"
        (vacTypeChange)="onVacTypeChange($event.vacId, $event.type)"
        (vacSubOptionChange)="
          onVacSubOptionChange($event.optionId, $event.answerId)
        "
        (previousStep)="currentStep = 1"
        (savePatient)="savePatient()"
        (searchTermChange)="onChildSearchTermChange($event)"
      ></app-patient-medical-info-step>
    </div>

    <div class="row g-4" *ngIf="currentStep === 3">
      <div class="col-12" style="margin-top: 21px">
        <div class="card bg-darker p-5">
          <div formGroupName="woundDetails">
            <div
              class="accordion-item mb-4"
            >
              <h2 class="accordion-header">
                <button class="accordion-button fw-bold fs-5" type="button">
                  {{ "patientCreate.woundAssessment.title" | translate }}
                </button>
              </h2>
              <div class="accordion-collapse collapse show" *ngIf="patientForm.get('woundDetails.hasWound')?.value !== false">
                <div class="accordion-body">
                  <div class="mb-4" *ngIf="!hasWoundFromQueryParam">
                    <label
                      class="form-label text-light fs-6 fw-bold mb-3 required"
                      >{{
                        "patientCreate.woundAssessment.hasWound" | translate
                      }}</label
                    >
                    <div class="d-flex gap-3">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="hasWoundYes"
                          [value]="true"
                          formControlName="hasWound"
                          (change)="onWoundStatusChange()"
                        />
                        <label
                          class="form-check-label text-light fs-6"
                          for="hasWoundYes"
                        >
                          {{ "patientCreate.woundAssessment.yes" | translate }}
                        </label>
                      </div>

                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="hasWoundNo"
                          [value]="false"
                          formControlName="hasWound"
                          (change)="onWoundStatusChange()"
                        />
                        <label
                          class="form-check-label text-light fs-6"
                          for="hasWoundNo"
                        >
                          {{ "patientCreate.woundAssessment.no" | translate }}
                        </label>
                      </div>

                      <div class="form-check">
                        <input
                          id="askToSpecialist"
                          class="form-check-input"
                          type="radio"
                          [value]="'ask'"
                          formControlName="hasWound"
                          (change)="onWoundStatusChange()"
                          [attr.disabled]="isAskDisabled ? true : null"
                        />
                        <label
                          class="form-check-label text-light fs-6"
                          for="askToSpecialist"
                        >
                          {{
                            "askToSpecialistModal.askToSpecialist" | translate
                          }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      patientForm.get('woundDetails.hasWound')?.value === true
                    "
                  >
                    <div class="row g-3">
                      <!-- Wound Type (Single Selection) -->
                      <div class="col-md-6">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.woundTypes"
                              | translate
                          }}</label
                        >
                        <app-select
                          formControlName="ulcerWoundType"
                          [items]="ulcerWoundTypeOptions"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="false"
                          [placeholder]="
                            'patientCreate.woundAssessment.woundTypes'
                              | translate
                          "
                        ></app-select>
                        <div
                          class="text-danger fs-12 mt-1"
                          *ngIf="
                            patientForm.get('woundDetails.ulcerWoundType')
                              ?.invalid &&
                            patientForm.get('woundDetails.ulcerWoundType')
                              ?.touched
                          "
                        >
                          {{ "patientCreate.validation.required" | translate }}
                        </div>
                      </div>

                      <!-- Symptoms (Single Selection) -->
                      <div class="col-md-6">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.symptoms" | translate
                          }}</label
                        >
                        <app-select
                          formControlName="symptoms"
                          [items]="symptomOptions"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="true"
                          [placeholder]="
                            'patientCreate.woundAssessment.symptoms' | translate
                          "
                        ></app-select>
                        <div
                          class="text-danger fs-12 mt-1"
                          *ngIf="
                            patientForm.get('woundDetails.symptoms')?.invalid &&
                            patientForm.get('woundDetails.symptoms')?.touched
                          "
                        >
                          {{ "patientCreate.validation.required" | translate }}
                        </div>
                      </div>

                      <!-- Discharge Type (Conditional - shown when symptoms=6) -->
                      <div class="col-md-6" *ngIf="isDischargeSelected">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.dischargeType"
                              | translate
                          }}</label
                        >
                        <app-select
                          formControlName="dischargeType"
                          [items]="dischargeTypeOptions"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="false"
                          [placeholder]="
                            'patientCreate.woundAssessment.dischargeType'
                              | translate
                          "
                        ></app-select>
                        <div
                          class="text-danger fs-12 mt-1"
                          *ngIf="
                            patientForm.get('woundDetails.dischargeType')
                              ?.invalid &&
                            patientForm.get('woundDetails.dischargeType')
                              ?.touched
                          "
                        >
                          {{ "patientCreate.validation.required" | translate }}
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.onset" | translate
                          }}</label
                        >
                        <input
                          type="text"
                          class="form-control bg-dark border-secondary text-light"
                          [placeholder]="
                            'patientCreate.woundAssessment.onsetPlaceholder'
                              | translate
                          "
                          formControlName="onset"
                        />
                      </div>

                      <!-- Healing Status (Single Selection) -->
                      <div class="col-md-6">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.healingStatus"
                              | translate
                          }}</label
                        >
                        <app-select
                          formControlName="healingStatus"
                          [items]="healingStatusOptions"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="false"
                          [placeholder]="
                            'patientCreate.woundAssessment.healingStatus'
                              | translate
                          "
                        ></app-select>
                        <div
                          class="text-danger fs-12 mt-1"
                          *ngIf="
                            patientForm.get('woundDetails.healingStatus')
                              ?.invalid &&
                            patientForm.get('woundDetails.healingStatus')
                              ?.touched
                          "
                        >
                          {{ "patientCreate.validation.required" | translate }}
                        </div>
                      </div>

                      <!-- Prior Management (Multiple Selection) -->
                      <div class="col-md-6">
                        <label
                          class="form-label text-light fs-12 mb-1 required"
                          >{{
                            "patientCreate.woundAssessment.priorManagement"
                              | translate
                          }}</label
                        >
                        <app-select
                          formControlName="priorManagement"
                          [items]="priorManagementOptions"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="true"
                          [multiple]="true"
                          appendTo="body"
                          [placeholder]="
                            'patientCreate.woundAssessment.priorManagement'
                              | translate
                          "
                        ></app-select>
                        <div
                          class="text-danger fs-12 mt-1"
                          *ngIf="
                            patientForm.get('woundDetails.priorManagement')
                              ?.invalid &&
                            patientForm.get('woundDetails.priorManagement')
                              ?.touched
                          "
                        >
                          {{ "patientCreate.validation.required" | translate }}
                        </div>
                      </div>

                      <div class="col-12">
                        <label
                          class="form-label text-light fs-12 mb-3 required"
                          >{{
                            "patientCreate.woundAssessment.painLevel"
                              | translate
                          }}</label
                        >
                        <div class="pain-level-slider">
                          <div class="d-flex justify-content-between mb-2">
                            <span class="text-light fs-12">{{
                              "patientCreate.woundAssessment.noPain" | translate
                            }}</span>
                            <span class="text-light fs-12">{{
                              "patientCreate.woundAssessment.moderatePain"
                                | translate
                            }}</span>
                            <span class="text-light fs-12">{{
                              "patientCreate.woundAssessment.worstPain"
                                | translate
                            }}</span>
                          </div>
                          <div class="position-relative">
                            <input
                              type="range"
                              class="form-range"
                              min="0"
                              max="10"
                              formControlName="painLevel"
                              [style.--slider-percentage.%]="
                                painSliderPercentage
                              "
                            />
                            <div class="pain-markers">
                              <div class="marker marker-0"></div>
                              <div class="marker marker-1"></div>
                              <div class="marker marker-2"></div>
                              <div class="marker marker-3"></div>
                              <div class="marker marker-4"></div>
                              <div class="marker marker-5"></div>
                              <div class="marker marker-6"></div>
                              <div class="marker marker-7"></div>
                              <div class="marker marker-8"></div>
                              <div class="marker marker-9"></div>
                              <div class="marker marker-10"></div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between mt-2">
                            <span class="fs-6 fw-bold">0</span>
                            <span class="badge badge-light-primary fs-5">{{
                              patientForm.get("woundDetails.painLevel")?.value
                            }}</span>
                            <span class="fs-6 fw-bold">10</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="isLoadingWoundQuestions"
              class="d-flex justify-content-center py-5"
            >
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div class="alert alert-danger" *ngIf="woundQuestionsError">
              {{ woundQuestionsError }}
            </div>
            <div
              *ngIf="
                !woundQuestionsError && questionGroups.length > 0
              "
              [style.opacity]="isLoadingWoundQuestions ? 0.55 : 1"
              [style.pointer-events]="
                isLoadingWoundQuestions ? 'none' : 'auto'
              "
            >
              <!-- Medical History Accordion -->
              <div
                class="accordion-item mb-3"
                *ngIf="patientForm.get('woundDetails.hasWound')?.value === true"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button fw-bold fs-5 d-flex justify-content-between align-items-center"
                    [class.collapsed]="!medicalHistoryOpen"
                    type="button"
                    (click)="medicalHistoryOpen = !medicalHistoryOpen"
                  >
                    <span class="d-flex align-items-center">
                      {{ "patientCreate.medicalHistoryTitle" | translate }}
                    </span>
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse"
                  [class.show]="medicalHistoryOpen"
                >
                  <div class="accordion-body">
                    <div formGroupName="medicalHistory">
                      <div class="medical-accordion">
                        <!-- Wound Care Products -->
                        <div class="accordion-card mb-3">
                          <div
                            class="accordion-header-custom"
                            [class.expanded]="accordionState.woundCareProducts"
                            (click)="toggleAccordion('woundCareProducts')"
                          >
                            <div
                              class="d-flex align-items-center justify-content-between w-100"
                            >
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="mb-0">
                                    {{
                                      "patientCreate.medicalHistory.woundCareProducts"
                                        | translate
                                    }}
                                  </h6>
                                  <span class="accordion-subtitle">{{
                                    "patientCreate.medicalHistory.woundTreatmentProducts"
                                      | translate
                                  }}</span>
                                </div>
                              </div>
                              <i
                                class="fas fa-chevron-down accordion-chevron"
                                [class.rotated]="
                                  accordionState.woundCareProducts
                                "
                              ></i>
                            </div>
                          </div>
                          <div
                            class="accordion-content"
                            [class.show]="accordionState.woundCareProducts"
                          >
                            <div class="nested-accordion">
                              <div
                                class="nested-card mb-2"
                                *ngFor="
                                  let category of woundCareProducts;
                                  let i = index
                                "
                              >
                                <div
                                  class="nested-header"
                                  [class.expanded]="category.isOpen"
                                  (click)="
                                    toggleNestedAccordion(woundCareProducts, i)
                                  "
                                >
                                  <span class="nested-title">{{
                                    category.categoryName
                                  }}</span>
                                  <i
                                    class="fas fa-chevron-right nested-chevron"
                                    [class.rotated]="category.isOpen"
                                  ></i>
                                </div>
                                <div
                                  class="nested-content"
                                  [class.show]="category.isOpen"
                                >
                                  <div class="checkbox-grid">
                                    <div
                                      class="checkbox-item"
                                      *ngFor="let product of category.items"
                                    >
                                      <input
                                        class="styled-checkbox"
                                        type="checkbox"
                                        [id]="'woundCareProduct-' + product.id"
                                        [checked]="
                                          isWoundCareProductSelected(product.id)
                                        "
                                        (change)="
                                          toggleWoundCareProduct(product.id)
                                        "
                                      />
                                      <label
                                        class="styled-label"
                                        [for]="'woundCareProduct-' + product.id"
                                      >
                                        {{ product.name }}
                                      </label>
                                    </div>
                                    <div
                                      class="empty-state"
                                      *ngIf="category.items.length === 0"
                                    >
                                      <i class="fas fa-info-circle me-2"></i>
                                      {{
                                        "patientCreate.medicalHistory.noWoundCareProducts"
                                          | translate
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="empty-state"
                                *ngIf="woundCareProducts.length === 0"
                              >
                                <i class="fas fa-info-circle me-2"></i>
                                {{
                                  "patientCreate.medicalHistory.noWoundCareProducts"
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Antibiotics -->
                        <div class="accordion-card mb-3">
                          <div
                            class="accordion-header-custom"
                            [class.expanded]="accordionState.antibiotics"
                            (click)="toggleAccordion('antibiotics')"
                          >
                            <div
                              class="d-flex align-items-center justify-content-between w-100"
                            >
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="mb-0">
                                    {{
                                      "patientCreate.medicalHistory.antibiotics"
                                        | translate
                                    }}
                                  </h6>
                                  <span class="accordion-subtitle">{{
                                    "patientCreate.medicalHistory.antibioticTreatmentHistory"
                                      | translate
                                  }}</span>
                                </div>
                              </div>
                              <i
                                class="fas fa-chevron-down accordion-chevron"
                                [class.rotated]="accordionState.antibiotics"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="accordion-content"
                            [class.show]="accordionState.antibiotics"
                          >
                            <div class="nested-accordion">
                              <div
                                class="nested-card mb-2"
                                *ngFor="
                                  let category of antibiotics;
                                  let i = index
                                "
                              >
                                <div
                                  class="nested-header"
                                  [class.expanded]="category.isOpen"
                                  (click)="
                                    toggleNestedAccordion(antibiotics, i)
                                  "
                                >
                                  <span class="nested-title">{{
                                    category.categoryName
                                  }}</span>
                                  <i
                                    class="fas fa-chevron-right nested-chevron"
                                    [class.rotated]="category.isOpen"
                                  ></i>
                                </div>
                                <div
                                  class="nested-content"
                                  [class.show]="category.isOpen"
                                >
                                  <div class="checkbox-grid">
                                    <div
                                      class="checkbox-item"
                                      *ngFor="let item of category.items"
                                    >
                                      <input
                                        class="styled-checkbox"
                                        type="checkbox"
                                        [id]="'antibiotic-' + item.id"
                                        [checked]="
                                          isAntibioticSelected(item.id)
                                        "
                                        (change)="toggleAntibiotic(item.id)"
                                      />
                                      <label
                                        class="styled-label"
                                        [for]="'antibiotic-' + item.id"
                                      >
                                        {{ item.name }}
                                      </label>
                                    </div>
                                    <div
                                      class="empty-state"
                                      *ngIf="category.items.length === 0"
                                    >
                                      <i class="fas fa-info-circle me-2"></i>
                                      {{
                                        "patientCreate.medicalHistory.noAntibiotics"
                                          | translate
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="empty-state"
                                *ngIf="antibiotics.length === 0"
                              >
                                <i class="fas fa-info-circle me-2"></i>
                                {{
                                  "patientCreate.medicalHistory.noAntibiotics"
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Debridement -->
                        <div class="accordion-card mb-3">
                          <div
                            class="accordion-header-custom"
                            [class.expanded]="accordionState.debridement"
                            (click)="toggleAccordion('debridement')"
                          >
                            <div
                              class="d-flex align-items-center justify-content-between w-100"
                            >
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="mb-0">
                                    {{
                                      "patientCreate.medicalHistory.debridement"
                                        | translate
                                    }}
                                  </h6>
                                  <span class="accordion-subtitle">{{
                                    "patientCreate.medicalHistory.woundDebridementMethods"
                                      | translate
                                  }}</span>
                                </div>
                              </div>
                              <i
                                class="fas fa-chevron-down accordion-chevron"
                                [class.rotated]="accordionState.debridement"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="accordion-content"
                            [class.show]="accordionState.debridement"
                          >
                            <div class="checkbox-grid">
                              <div
                                class="checkbox-item"
                                *ngFor="let debridement of debridements"
                              >
                                <input
                                  class="styled-checkbox"
                                  type="checkbox"
                                  [id]="'debridement-' + debridement.id"
                                  [checked]="
                                    isDebridementSelected(debridement.id)
                                  "
                                  (change)="toggleDebridement(debridement.id)"
                                />
                                <label
                                  class="styled-label"
                                  [for]="'debridement-' + debridement.id"
                                >
                                  {{ debridement.name }}
                                </label>
                              </div>
                              <div
                                class="empty-state"
                                *ngIf="debridements.length === 0"
                              >
                                <i class="fas fa-info-circle me-2"></i>
                                {{
                                  "patientCreate.medicalHistory.noDebridements"
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Vacuum Assisted Closure (VAC) -->
                        <div class="accordion-card mb-3">
                          <div
                            class="accordion-header-custom"
                            [class.expanded]="accordionState.vac"
                            (click)="toggleAccordion('vac')"
                          >
                            <div
                              class="d-flex align-items-center justify-content-between w-100"
                            >
                              <div class="d-flex align-items-center">
                                <div>
                                  <h6 class="mb-0">
                                    {{
                                      "patientCreate.medicalHistory.vacuumAssistedClosure"
                                        | translate
                                    }}
                                  </h6>
                                  <span class="accordion-subtitle">{{
                                    "patientCreate.medicalHistory.negativePressureTherapy"
                                      | translate
                                  }}</span>
                                </div>
                              </div>
                              <i
                                class="fas fa-chevron-down accordion-chevron"
                                [class.rotated]="accordionState.vac"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="accordion-content"
                            [class.show]="accordionState.vac"
                          >
                            <div class="vac-options">
                              <div
                                class="radio-card"
                                *ngFor="let vac of vacList"
                              >
                                <input
                                  class="styled-radio"
                                  type="radio"
                                  [id]="'vac-type-' + vac.vacuumType"
                                  name="vacType"
                                  [value]="vac.vacuumType"
                                  [checked]="selectedVacType === vac.vacuumType"
                                  (click)="
                                    onVacTypeChange(vac.id, vac.vacuumType)
                                  "
                                />
                                <label
                                  class="radio-label"
                                  [for]="'vac-type-' + vac.vacuumType"
                                >
                                  <span class="radio-title">
                                    {{
                                      vac.vacuumType === 0
                                        ? ("patientCreate.medicalHistory.vac.abdominal"
                                          | translate)
                                        : ("patientCreate.medicalHistory.vac.sponge"
                                          | translate)
                                    }}
                                  </span>
                                </label>

                                <div
                                  class="vac-suboptions"
                                  *ngIf="
                                    vac.vacuumType === 1 &&
                                    selectedVacType === 1
                                  "
                                >
                                  <div
                                    class="suboption-group"
                                    *ngFor="let option of getSpongeOptions()"
                                  >
                                    <label class="suboption-label">
                                      {{ option.title }}
                                      <span class="text-danger fs-12 mt-1"
                                        >*</span
                                      >
                                    </label>
                                    <div class="suboption-buttons">
                                      <div
                                        class="suboption-btn"
                                        *ngFor="
                                          let sub of option.vacuumAssistedClosureSubOptionAnswers
                                        "
                                        [class.selected]="
                                          isVacSubOptionSelected(
                                            option.id,
                                            sub.id
                                          )
                                        "
                                        (click)="
                                          onVacSubOptionChange(
                                            option.id,
                                            sub.id
                                          )
                                        "
                                      >
                                        {{ sub.name }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="empty-state"
                                *ngIf="vacList.length === 0"
                              >
                                <i class="fas fa-info-circle me-2"></i>
                                {{
                                  "patientCreate.medicalHistory.vac.noOptions"
                                    | translate
                                }}
                              </div>
                              <div
                                class="alert-warning-custom"
                                *ngIf="
                                  selectedVacType === 1 &&
                                  vacTouched &&
                                  !isVacValid()
                                "
                              >
                                <i class="fas fa-exclamation-triangle me-2"></i>
                                {{
                                  "patientCreate.medicalHistory.vac.missingSpongeAnswers"
                                    | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="accordion-item mb-3"
                *ngFor="
                  let group of questionGroups;
                  let i = index;
                  trackBy: trackByQuestionGroup
                "
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button fw-bold fs-5 d-flex justify-content-between align-items-center"
                    [class.collapsed]="!group.isOpen"
                    type="button"
                    (click)="group.isOpen = !group.isOpen"
                  >
                    <span>{{ getDisplayGroupTitle(group) }}</span>
                    <ng-container
                      *ngIf="
                        getGroupScore(group.questions[0]?.templateId) &&
                        !(group.code || '')?.toLowerCase().includes('vcss')
                      "
                    >
                      <!-- GLASS badge -->
                      <ng-container *ngIf="isGlassGroup(group)">
                        <span
                          class="badge ms-3"
                          style="
                            font-size: 0.875rem;
                            padding: 0.5rem 1rem;
                            background-color: #44301e;
                            color: white;
                          "
                        >
                          GLASS {{ getGroupScore(group.questions[0]?.templateId)?.totalScore }}
                        </span>
                      </ng-container>

                      <!-- Diğer scoreler -->
                      <span
                        *ngIf="!isGlassGroup(group)"
                        class="badge ms-3"
                        style="
                          font-size: 0.875rem;
                          padding: 0.5rem 1rem;
                          background-color: #44301e;
                          color: white;
                        "
                      >
                        <ng-container
                          *ngIf="
                            (group.code || '')?.toLowerCase().includes('fontaine')
                          "
                        >
                          {{
                            formatFontaine(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            )
                          }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            (group.code || '')?.toLowerCase().includes('ceap')
                          "
                        >
                          {{
                            getGroupScore(group.questions[0]?.templateId)
                              ?.riskCategoryName
                          }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            !(group.code || '')?.toLowerCase().includes('ceap') &&
                            !(group.code || '')
                              ?.toLowerCase()
                              .includes('fontaine')
                          "
                        >
                          <ng-container
                            *ngIf="isWifiGroup(group)"
                          >
                            {{
                              getWifiStageText(
                                getGroupScore(group.questions[0]?.templateId)
                                  ?.totalScore
                              )
                            }}
                            <ng-container
                              *ngIf="
                                getGroupScore(group.questions[0]?.templateId)
                                  ?.totalScore
                              "
                            >
                              -
                              {{
                                getWifiRiskLevelText(
                                  getGroupScore(group.questions[0]?.templateId)
                                    ?.totalScore
                                )
                              }}
                            </ng-container>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              !isWifiGroup(group) &&
                              (group.code || '')?.toLowerCase().includes('iwgdf')
                            "
                          >
                            {{
                              formatIWGDFRiskLevel(
                                getGroupScore(group.questions[0]?.templateId)
                                  ?.totalScore
                              )
                            }}
                          </ng-container>
                          <ng-container
                            *ngIf="
                              !isWifiGroup(group) &&
                              !(group.code || '')?.toLowerCase().includes('iwgdf')
                            "
                          >
                            {{
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            }}
                            <ng-container
                              *ngIf="
                                getGroupScore(group.questions[0]?.templateId)
                                  ?.riskCategoryName
                              "
                            >
                              -
                              {{
                                getGroupScore(group.questions[0]?.templateId)
                                  ?.riskCategoryName
                              }}
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </span>
                    </ng-container>
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse"
                  [class.show]="group.isOpen"
                >
                  <div class="accordion-body">
                    <div
                      *ngIf="
                        isIWGDFGroup(group) &&
                        getIWGDFFollowUpText(
                          getGroupScore(group.questions[0]?.templateId)
                        )
                      "
                      class="alert alert-info d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4"
                    >
                      <span class="fw-semibold">
                        {{
                          "patientCreate.woundAssessment.iwgdfFollowUp.label"
                            | translate
                        }}
                      </span>
                      <span>
                        {{
                          getIWGDFFollowUpText(
                            getGroupScore(group.questions[0]?.templateId)
                          )
                        }}
                      </span>
                    </div>

                    <div
                      *ngIf="
                        isWifiGroup(group) &&
                        getGroupScore(group.questions[0]?.templateId)
                      "
                      class="alert alert-info d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4"
                    >
                      <div class="d-flex flex-column gap-1">
                        <span class="fw-semibold">
                          {{
                            getWifiStageText(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            )
                          }}
                        </span>
                        <span>
                          {{
                            getWifiRiskLevelText(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            )
                          }}
                        </span>
                        <span>
                          {{
                            "patientCreate.woundAssessment.wifi.majorAmputationRate"
                              | translate
                          }}:
                          {{
                            getWifiMajorAmputationRate(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            )
                          }}
                        </span>
                      </div>

                      <div
                        *ngIf="getWifiBreakdownForGroup(group) as breakdown"
                        class="text-end"
                      >
                        <div>
                          {{
                            "patientCreate.woundAssessment.wifi.components"
                              | translate
                          }}
                        </div>
                        <div>
                          W-{{ breakdown.wound }} / I-{{
                            breakdown.ischemia
                          }} / FI-{{ breakdown.footInfection }}
                        </div>
                      </div>
                    </div>

                    <div
                      *ngIf="
                        isGlassGroup(group) &&
                        getGroupScore(group.questions[0]?.templateId)
                      "
                      class="alert alert-info d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4"
                    >
                      <div class="d-flex flex-column gap-1">
                        <span class="fw-semibold">
                          {{
                            getGlassStageText(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore
                            )
                          }}
                        </span>
                        <span>
                          {{
                            "patientCreate.woundAssessment.glass.summary.recommendation"
                              | translate
                          }}:
                          {{
                            getGlassTreatmentRecommendationText(
                              getGroupScore(group.questions[0]?.templateId)
                                ?.totalScore,
                              getWifiScoreForGlass() || undefined
                            )
                          }}
                        </span>
                      </div>

                      <div
                        *ngIf="getGlassBreakdownForGroup(group) as breakdown"
                        class="text-end"
                      >
                        <div>
                          {{
                            "patientCreate.woundAssessment.glass.summary.stagingInputs"
                              | translate
                          }}
                        </div>
                        <div>
                          FP-{{ breakdown.fp ?? "—" }} / IP-{{
                            breakdown.ip ?? "—"
                          }}
                        </div>
                      </div>
                    </div>

                    <app-glass-score-selector
                      *ngIf="isGlassGroup(group)"
                      [group]="group"
                      [wifiStage]="getWifiScoreForGlass()"
                      [disabledMessage]="getGlassGroupDisabledMessage(group)"
                      (optionSelected)="onGlassOptionSelected($event)"
                      (selectionChanged)="onGlassSelectionChanged(group.questions[0]?.templateId, $event)"
                    ></app-glass-score-selector>

                    <div
                      *ngIf="
                        !isGlassGroup(group) && getUIType(group.code) === 'cards'
                      "
                    >
                      <div class="row g-3">
                        <ng-container
                          *ngFor="
                            let q of group.questions;
                            trackBy: trackByQuestionId
                          "
                        >
                          <div class="col-md-4" *ngFor="let opt of q.options">
                            <div
                              class="wound-stage-card p-4 text-center cursor-pointer"
                              [class.selected]="q.answerOptionId === opt.id"
                              (click)="onQuestionOptionClick(q, opt.id, $event)"
                              (mouseenter)="showTooltip($event, opt.tooltip)"
                              (mousemove)="updateTooltipPosition($event)"
                              (mouseleave)="hideTooltip()"
                            >
                              <div class="fw-bold fs-4 text-white">
                                {{ getDisplayOptionText(opt.text) }}
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      *ngIf="
                        !isGlassGroup(group) && getUIType(group.code) === 'grid'
                      "
                    >
                      <div class="row g-3">
                        <ng-container
                          *ngFor="
                            let q of group.questions;
                            trackBy: trackByQuestionId
                          "
                        >
                          <div class="col-md-3" *ngFor="let opt of q.options">
                            <div
                              class="ceap-card p-3 cursor-pointer"
                              [class.selected]="q.answerOptionId === opt.id"
                              (click)="onQuestionOptionClick(q, opt.id, $event)"
                              (mouseenter)="showTooltip($event, opt.tooltip)"
                              (mousemove)="updateTooltipPosition($event)"
                              (mouseleave)="hideTooltip()"
                            >
                              <div class="text-light fs-12 text-center">
                                {{ getDisplayOptionText(opt.text) }}
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      *ngIf="
                        !isGlassGroup(group) && getUIType(group.code) === 'list'
                      "
                    >
                      <div class="d-flex flex-column gap-4">
                        <ng-container
                          *ngFor="
                            let q of group.questions;
                            trackBy: trackByQuestionId
                          "
                        >
                          <!-- Custom Weight Loss Question Inputs -->
                          <div
                            *ngIf="q.shortCode === 'WEIGHT_LOST'"
                            class="mb-3"
                          >
                            <label
                              class="form-label text-light fs-6 fw-bold mb-2"
                              >{{ getDisplayQuestionText(q.text) }}</label
                            >
                            <div class="row g-3" [formGroup]="patientForm">
                              <div
                                class="col-md-6"
                                formGroupName="woundDetails"
                              >
                                <label
                                  class="form-label text-light fs-12 mb-1"
                                  >{{
                                    "patientCreate.woundAssessment.weight3MonthsAgo"
                                      | translate
                                  }}</label
                                >
                                <input
                                  type="number"
                                  class="form-control bg-dark border-secondary text-light"
                                  formControlName="previousWeight"
                                  (blur)="onWeightInput()"
                                  placeholder="Enter weight"
                                  appDecimalOnly
                                />
                              </div>
                              <div
                                class="col-md-6"
                                formGroupName="woundDetails"
                              >
                                <label
                                  class="form-label text-light fs-12 mb-1"
                                  >{{
                                    "patientCreate.woundAssessment.currentWeight"
                                      | translate
                                  }}</label
                                >
                                <input
                                  type="number"
                                  class="form-control bg-dark border-secondary text-light"
                                  formControlName="currentWeight"
                                  (blur)="onWeightInput()"
                                  placeholder="Enter weight"
                                  appDecimalOnly
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            class="disabled-question-wrapper position-relative"
                            [class.is-disabled]="q.isDisabled"
                            *ngIf="
                              q.id !== '2130cd8e-9474-46f6-9f93-ccfc293818f5'
                            "
                          >
                            <div class="disabled-tooltip" *ngIf="q.isDisabled">
                              {{ q.disabledReason | translate }}
                            </div>
                            <div [class.disabled-question]="q.isDisabled">
                              <div
                                class="bg-dark p-3 rounded text-light fs-6 fw-semibold mb-2 d-flex justify-content-between align-items-center"
                              >
                                <span>{{ getDisplayQuestionText(q.text) }}</span>
                                <span
                                  class="badge badge-light-secondary ms-2"
                                  *ngIf="q.isDisabled"
                                  >{{ "assessment.disabled" | translate }}</span
                                >
                              </div>
                              <div class="d-flex gap-3 flex-wrap">
                                <div
                                  class="form-check"
                                  *ngFor="let opt of q.options"
                                >
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    [name]="'q-' + q.id"
                                    [id]="'opt-' + opt.id"
                                    [value]="opt.id"
                                    [checked]="q.answerOptionId === opt.id"
                                    [disabled]="q.isDisabled"
                                    (click)="
                                      onQuestionOptionClick(q, opt.id, $event)
                                    "
                                  />
                                  <label
                                    class="form-check-label text-light"
                                    [class.cursor-not-allowed]="q.isDisabled"
                                    [for]="'opt-' + opt.id"
                                    (mouseenter)="
                                      showTooltip($event, opt.tooltip)
                                    "
                                    (mousemove)="updateTooltipPosition($event)"
                                    (mouseleave)="hideTooltip()"
                                    >{{ getDisplayOptionText(opt.text) }}</label
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom tooltip element -->
            <div
              class="risk-tooltip"
              *ngIf="activeTooltip"
              [style.left.px]="activeTooltip.x"
              [style.top.px]="activeTooltip.y"
            >
              {{ activeTooltip.text }}
            </div>

            <div
              class="alert alert-info"
              *ngIf="
                !isLoadingWoundQuestions &&
                !woundQuestionsError &&
                questionGroups.length === 0 &&
                patientForm.get('woundDetails.hasWound')?.value !== null &&
                patientForm.get('woundDetails.hasWound')?.value == 'ask'
              "
            >
              {{ "patientCreate.woundAssessment.noQuestions" | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-between mt-4">
        <button
          type="button"
          class="btn btn-outline-secondary px-4 py-2"
          *ngIf="false"
          (click)="goToStep(currentStep - 1)"
        >
          {{ "patientCreate.form.previous" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-warning text-dark fw-bold px-4 py-2 ms-auto"
          (click)="calculateAssessmentScores()"
          [disabled]="isCalculateButtonDisabled"
        >
          {{ "patientCreate.woundAssessment.calculateScores" | translate }}
          <i class="fas fa-calculator ms-2"></i>
        </button>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-between mt-4">
      <button
        type="button"
        class="btn btn-outline-secondary px-4 py-2"
        *ngIf="currentStep > 1 && currentStep !== 3"
        (click)="currentStep = currentStep - 1"
      >
        {{ "patientCreate.form.previous" | translate }}
      </button>

      <button
        type="button"
        class="btn btn-warning text-dark fw-bold px-4 py-2"
        *ngIf="currentStep === 2 && !patientSaved"
        (click)="savePatient()"
      >
        {{ "patientCreate.form.save" | translate }}
        <i class="fas fa-save ms-2"></i>
      </button>
    </div>
  </form>
</div>
